import React from "react";
import { Form, Input } from "antd";
import PhoneNumber from "../components/Phone";

import ICON_X from "../assets/x.svg";
import ICON_YELP from "../assets/yelp.svg";
import ICON_GOOGLE from "../assets/google.svg";
import ICON_LINKEDIN from "../assets/linkedin.svg";
import StepHeader from "./StepHeader";

import type { TypePersonalInfoProps } from "./PersonalInfo";

interface TypeConcatInfoProps extends TypePersonalInfoProps {}

type TypeContactInfoComp = React.FC<TypeConcatInfoProps> & {
  REQUIRED: typeof FORM_REQUIRED_FIELDS;
};

// 必填的字段
const FORM_REQUIRED_FIELDS = {
  Email: ["LandingPageSetUp", "Email"],
  Phone: ["Phone"],
};

/**
 * @name ConcatInfo 联系方式
 */
const ContactInfo: TypeContactInfoComp = ({
  badge,
  intro,
  title = "How can borrowers reach you?",
}) => (
  <div className="layout-profile-ctx">
    <StepHeader title={title} badge={badge} intro={intro} />

    <Form.Item
      label="Email"
      name={FORM_REQUIRED_FIELDS.Email}
      rules={[
        {
          type: "email",
          required: true,
          message: "Please enter the correct e-mail address",
        },
      ]}
      tooltip="This email will be shown to borrowers as your contact email. We recommend using your Zeitro account email to avoid confusion, as all system notifications will go there."
    >
      <Input placeholder="example@email.com" />
    </Form.Item>

    <Form.Item
      label="Phone number"
      name={FORM_REQUIRED_FIELDS.Phone}
      rules={[
        {
          required: true,
          message: "Please enter a valid phone number (10 digits).",
        },
        {
          pattern: /^\([1-9][0-9]{2}\) [0-9]{3}-[0-9]{4}$/,
          message: "Please enter a valid phone number (10 digits).",
        },
      ]}
    >
      <PhoneNumber placeholder="(000) 0000-000" />
    </Form.Item>

    <label className="website-form-label">Social media links (optional)</label>

    <Form.Item
      label="Google"
      name={["LandingPageSetUp", "Google"]}
      rules={[{ type: "url", message: "Please enter a valid URL" }]}
    >
      <Input
        prefix={<img src={ICON_GOOGLE} />}
        placeholder="Please enter the link address"
      />
    </Form.Item>

    <Form.Item
      label="Linkedin"
      name={["LandingPageSetUp", "Linkedin"]}
      rules={[{ type: "url", message: "Please enter a valid URL" }]}
    >
      <Input
        prefix={<img src={ICON_LINKEDIN} />}
        placeholder="Please enter the link address"
      />
    </Form.Item>

    <Form.Item
      label="X (Twitter)"
      name={["LandingPageSetUp", "Twitter"]}
      rules={[{ type: "url", message: "Please enter a valid URL" }]}
    >
      <Input
        prefix={<img src={ICON_X} />}
        placeholder="Please enter the link address"
      />
    </Form.Item>

    <Form.Item
      label="Yelp"
      name={["LandingPageSetUp", "Yelp"]}
      rules={[{ type: "url", message: "Please enter a valid URL" }]}
    >
      <Input
        prefix={<img src={ICON_YELP} />}
        placeholder="Please enter the link address"
      />
    </Form.Item>
  </div>
);

ContactInfo.REQUIRED = FORM_REQUIRED_FIELDS;

export default ContactInfo;
